module.exports = __webpack_public_path__ + "img/map-es.20127f19.png";